<script lang="ts">
    import { t } from '$lib/i18n';
    
    export let live_broadcast_content: 'live' | 'upcoming' | 'none';
</script>

{#if live_broadcast_content !== 'live'}
    <div class="lg:hidden flex items-center justify-center px-4 py-3 backdrop-blur-sm border-b border-neutral-200 dark:border-neutral-800">
        <div class="flex items-center justify-between w-full max-w-[280px]">
            <a 
                href="/live-rankings" 
                class="group flex items-center gap-1.5 text-neutral-600 dark:text-neutral-400 hover:text-neutral-950 dark:hover:text-white transition-colors"
            >
                <span class="text-sm font-medium">{t('video_page.live_now', '配信中')}</span>
                <svg class="w-4 h-4 transition-transform group-hover:translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M5 12h14m-7-7 7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
            <a 
                href="/schedule" 
                class="group flex items-center gap-1.5 text-neutral-600 dark:text-neutral-400 hover:text-neutral-950 dark:hover:text-white transition-colors"
            >
                <span class="text-sm font-medium">番組表</span>
                <svg class="w-4 h-4 transition-transform group-hover:translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M5 12h14m-7-7 7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
            <a 
                href="/search" 
                class="group flex items-center gap-1.5 text-neutral-600 dark:text-neutral-400 hover:text-neutral-950 dark:hover:text-white transition-colors"
            >
                <span class="text-sm font-medium">検索</span>
                <svg class="w-4 h-4 transition-transform group-hover:translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M5 12h14m-7-7 7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
        </div>
    </div>
{/if} 